export default __webpack_public_path__ + "static/media/project3.14414222.jpg";